module.exports = __webpack_public_path__ + "img/134.c7e8c747.jpg";